import Checkbox from '../input/Checkbox';
import './FilterValueCheckbox.less';

export type FilterValueCheckboxProps = {
    label: string;
    isChecked: boolean;
    onToggle: () => void;
};

const FilterValueCheckbox = ({
    isChecked,
    label,
    onToggle
}: FilterValueCheckboxProps) => (
    <div className={`bri-FilterValueCheckbox`}>
        <Checkbox
            checked={isChecked}
            className="bri-Body2Font"
            onChange={() => onToggle()}
        >
            {label}
        </Checkbox>
    </div>
);

export default FilterValueCheckbox;
